/* =========================================================================
   VELMAINE — global.js
   One deferred script, no dependencies. Sections:
     1 utils · 2 overlays (drawers/sheets) · 3 header · 4 cart · 5 variant forms
     6 quick add + one-tap add · 7 PDP (gallery, video, sticky ATC, styled with, recs)
     8 hero video · 9 search · 10 collection tools · 11 delivery dates · 12 email popup
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- 1. Utils ------------------------------------------------- */
  var VM = window.VM || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  function money(cents) {
    var fmt = VM.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function store(kind) {
    try { var s = window[kind]; var k = '__vm'; s.setItem(k, k); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var local = store('localStorage');
  var session = store('sessionStorage');
  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.hidden = true; }, 3200);
  }
  function withQuery(url, params) {
    var u = new URL(url, window.location.origin);
    Object.keys(params).forEach(function (k) { u.searchParams.set(k, params[k]); });
    return u.pathname + u.search;
  }

  /* ---------- 2. Overlays: drawers + sheets ----------------------------- */
  var scrim = $('[data-scrim]');
  var openStack = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function overlayEl(kind, name) { return $('[data-' + kind + '="' + name + '"]'); }

  function openOverlay(el, trigger) {
    if (!el) return;
    if (openStack.indexOf(el) === -1) openStack.push(el);
    el.hidden = false;
    el._trigger = trigger || document.activeElement;
    if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('vm-locked');
    // next frame so the transform transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
    if (el.getAttribute('data-drawer') === 'cart') { Cart.loadRecs(); Savings.reveal(el); }
    var first = $('[data-predictive-input]', el) || $(FOCUSABLE, el);
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 30);
  }

  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    var idx = openStack.indexOf(el);
    if (idx > -1) openStack.splice(idx, 1);
    var dur = reducedMotion ? 0 : 230;
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, dur);
    if (el._trigger && el._trigger.hasAttribute && el._trigger.hasAttribute('aria-expanded')) el._trigger.setAttribute('aria-expanded', 'false');
    if (!openStack.length) {
      if (scrim) scrim.hidden = true;
      document.body.classList.remove('vm-locked');
    }
    if (el._trigger && document.contains(el._trigger)) el._trigger.focus({ preventScroll: true });
    el.dispatchEvent(new CustomEvent('vm:closed', { bubbles: true }));
  }
  function closeTop() { if (openStack.length) closeOverlay(openStack[openStack.length - 1]); }
  function openDrawer(name, trigger) { openOverlay(overlayEl('drawer', name), trigger); }
  function openSheet(name, trigger) { openOverlay(overlayEl('sheet', name), trigger); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      var name = opener.getAttribute('data-drawer-open');
      // open the filter drawer at a specific group when a chip was tapped
      if (name === 'filters' && opener.hasAttribute('data-filter-focus')) {
        var group = $('[data-filter-group="' + opener.getAttribute('data-filter-focus') + '"]');
        if (group) { group.open = true; setTimeout(function () { group.scrollIntoView({ block: 'start' }); }, 60); }
      }
      openDrawer(name, opener);
      return;
    }
    var sheetOpener = t.closest('[data-sheet-open]');
    if (sheetOpener) { e.preventDefault(); openSheet(sheetOpener.getAttribute('data-sheet-open'), sheetOpener); return; }
    if (t.closest('[data-search-open]')) {
      e.preventDefault();
      var menu = overlayEl('drawer', 'menu');
      if (menu && menu.classList.contains('is-open')) closeOverlay(menu);
      openDrawer('search', t.closest('[data-search-open]'));
      return;
    }
    if (t.closest('[data-drawer-close]') || t.closest('[data-sheet-close]')) {
      closeOverlay(t.closest('[data-drawer], [data-sheet]'));
      return;
    }
    if (t === scrim) { while (openStack.length) closeOverlay(openStack[openStack.length - 1]); return; }
    // tapping the empty area around a sheet panel closes it
    if (t.matches && t.matches('[data-sheet]')) closeOverlay(t);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openStack.length) { closeTop(); return; }
    if (e.key !== 'Tab' || !openStack.length) return;
    var el = openStack[openStack.length - 1];
    var items = $$(FOCUSABLE, el).filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- 2b. Keep drawers at the top level ------------------------
     The menu drawer is rendered inside the header section, whose sticky wrapper is its own
     stacking layer; left there, the page scrim covers the open menu. Move it to <body>. */
  function liftDrawers() {
    $$('#shopify-section-header [data-drawer]').forEach(function (d) { document.body.appendChild(d); });
  }
  liftDrawers();
  document.addEventListener('shopify:section:load', function () {
    $$('body > [data-drawer="menu"]').forEach(function (old) {
      if ($('#shopify-section-header [data-drawer="menu"]')) old.remove();
    });
    liftDrawers();
  });

  /* ---------- 3. Header: sticky on scroll-up only, mega menu Esc -------- */
  (function header() {
    var el = $('[data-header]');
    if (!el) return;
    var lastY = window.scrollY;
    var ticking = false;
    var rootStyle = document.documentElement.style;
    var syncTop = function () {
      rootStyle.setProperty('--vm-sticky-top', el.classList.contains('is-hidden') ? '0px' : el.offsetHeight + 'px');
    };
    syncTop();
    window.addEventListener('resize', syncTop);
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var h = el.offsetHeight;
        if (y > lastY && y > h * 2) el.classList.add('is-hidden');
        else if (y < lastY) el.classList.remove('is-hidden');
        syncTop();
        lastY = y; ticking = false;
      });
    }, { passive: true });

    $$('.vm-nav__item--mega', el).forEach(function (item) {
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { item.classList.add('is-closed'); $('.vm-nav__link', item).focus(); }
      });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-closed'); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) item.classList.remove('is-closed'); });
    });
  })();

  /* ---------- 4. Cart --------------------------------------------------- */
  var Cart = {
    drawer: function () { return overlayEl('drawer', 'cart'); },

    render: function (sections, newKeys) {
      var html = sections && sections['cart-drawer'];
      var drawer = Cart.drawer();
      if (!html || !drawer) return;
      var doc = parseHTML(html);
      var next = $('[data-cart-dynamic]', doc);
      var curr = $('[data-cart-dynamic]', drawer);
      var prevSave = curr && $('[data-savings]', curr) ? parseInt($('[data-savings]', curr).getAttribute('data-amount'), 10) || 0 : 0;
      var prevPct = curr && $('[data-vprog]', curr) ? parseFloat($('[data-vprog]', curr).getAttribute('data-pct')) || 0 : 0;
      var nextDrawer = $('[data-drawer="cart"]', doc);
      if (next && curr) curr.replaceWith(next);
      if (nextDrawer) drawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
      var count = parseInt(next && next.getAttribute('data-count'), 10);
      if (isNaN(count)) count = $$('.vm-line', drawer).reduce(function (n, line) {
        return n + (parseInt(($('.vm-qty__value', line) || {}).textContent, 10) || 0);
      }, 0);
      Cart.setCount(count);
      (newKeys || []).forEach(function (key) {
        var line = $('.vm-line[data-key="' + key + '"]', drawer);
        if (line) line.classList.add('is-new');
      });
      Savings.progress(drawer, prevPct);
      Savings.count(drawer, prevSave);
      Cart.loadRecs();
    },

    // "Complete the outfit": loaded after the drawer renders so it never delays the bag.
    loadRecs: function () {
      var drawer = Cart.drawer();
      var box = drawer && $('[data-cart-recs]', drawer);
      if (!box || box.children.length || box._loading) return;
      box._loading = true;
      fetch(box.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var inner = html && $('.vm-upsell__inner', parseHTML(html));
          if (inner && document.contains(box)) box.appendChild(inner);
        })
        .catch(function () {})
        .finally(function () { box._loading = false; });
    },

    setCount: function (count) {
      VM.cartCount = count;
      document.dispatchEvent(new CustomEvent('vm:cart', { detail: { count: count } }));
      $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
      $$('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items')); });
    },

    request: function (url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var msg = data.description || data.message || VM.strings.error;
            throw new Error(msg);
          }
          return data;
        });
      });
    },

    // Opens the drawer straight away (before the network returns) so the tap feels instant.
    add: function (items, trigger) {
      var drawer = Cart.drawer();
      if (drawer) { drawer.classList.add('is-busy'); openOverlay(drawer, trigger); }
      return Cart.request((VM.routes.cartAdd || '/cart/add') + '.js', { items: items })
        .then(function (data) {
          Cart.render(data.sections, (data.items || []).map(function (i) { return i.key; }));
          return data;
        })
        .catch(function (err) { if (drawer) closeOverlay(drawer); toast(err.message); throw err; })
        .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
    },

    change: function (key, quantity, lineEl) {
      if (lineEl) lineEl.classList.add('is-updating');
      return Cart.request((VM.routes.cartChange || '/cart/change') + '.js', { id: key, quantity: quantity })
        .then(function (data) { Cart.render(data.sections); })
        .catch(function (err) { if (lineEl) lineEl.classList.remove('is-updating'); toast(err.message); });
    }
  };

  // Checkout: quicken the light sweep while the browser heads to checkout
  document.addEventListener('submit', function (e) {
    var btn = e.submitter && e.submitter.classList.contains('vm-checkout') ? e.submitter : null;
    if (btn) btn.classList.add('is-loading');
  });

  /* ---------- 4b. Savings: progress fill, count-up, tier card ---------- */
  var Savings = {
    // Fill the volume progress bar from its previous width to the new one
    progress: function (root, fromPct) {
      var bar = $('[data-vprog]', root);
      var fill = bar && $('[data-vprog-fill]', bar);
      if (!fill) return;
      var to = parseFloat(bar.getAttribute('data-pct')) || 0;
      if (reducedMotion || to === fromPct) return;
      fill.style.transition = 'none';
      fill.style.width = fromPct + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = to + '%';
    },
    // Count the "You're saving" amount up from the previous value and pulse the row
    count: function (root, fromCents) {
      var row = $('[data-savings]', root);
      if (!row) return;
      var to = parseInt(row.getAttribute('data-amount'), 10) || 0;
      row._shown = true;
      if (to <= fromCents) return;
      Savings.animate(row, fromCents, to);
    },
    // First time the drawer opens on a page, count up from zero
    reveal: function (drawer) {
      var row = $('[data-savings]', drawer);
      if (!row || row._shown) return;
      row._shown = true;
      Savings.animate(row, 0, parseInt(row.getAttribute('data-amount'), 10) || 0);
    },
    animate: function (row, from, to) {
      var out = $('[data-savings-amount]', row);
      if (!out) return;
      if (reducedMotion) { out.textContent = money(to); return; }
      row.classList.remove('is-bump');
      void row.offsetWidth;
      row.classList.add('is-bump');
      var start = null, dur = 800;
      var step = function (ts) {
        if (!start) start = ts;
        var k = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - k, 3);
        out.textContent = money(Math.round(from + (to - from) * eased));
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    },
    tierFor: function (n) {
      var hit = null;
      (VM.volume || []).forEach(function (t) { if (n >= t.qty) hit = t; });
      return hit;
    },
    // PDP card: highlight the tier this item would unlock, given the bag
    card: function () {
      var card = $('[data-vcard]');
      var tiers = VM.volume || [];
      if (!card || !tiers.length) return;
      var n = (VM.cartCount || 0) + 1;
      var hit = Savings.tierFor(n);
      $$('[data-tier-qty]', card).forEach(function (li) {
        li.classList.toggle('is-active', !!hit && parseInt(li.getAttribute('data-tier-qty'), 10) === hit.qty);
      });
      var msg = $('[data-vcard-msg]', card);
      if (!msg) return;
      if (hit) {
        msg.innerHTML = 'Add this to your bag and save <strong>' + hit.pct + '%</strong> on your order. Applied automatically at checkout.';
      } else {
        var need = tiers[0].qty - n;
        msg.innerHTML = 'Add this plus ' + need + ' more ' + (need === 1 ? 'piece' : 'pieces') + ' to save <strong>' + tiers[0].pct + '%</strong>. Applied automatically at checkout.';
      }
    }
  };
  document.addEventListener('vm:cart', function () { Savings.card(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var line = btn.closest('[data-key]');
    if (!line) return;
    e.preventDefault();
    Cart.change(line.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty-change'), 10), line);
  });

  /* ---------- 5. Variant forms (PDP + quick add) ------------------------ */
  function VariantForm(root) {
    this.root = root;
    this.form = $('[data-product-form]', root);
    var json = $('[data-variant-json]', root);
    this.variants = json ? JSON.parse(json.textContent) : [];
    this.fieldsets = $$('[data-option-index]', root);
    this.idInput = $('[data-variant-id]', root);
    this.button = $('[data-add-button]', root);
    this.error = $('[data-form-error]', root);
    this.isPDP = root.hasAttribute('data-pdp');
    if (!this.form) return;
    root._vf = this;
    var self = this;
    this.fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { self.onChange(fs); }); });
    this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    this.update(false);
  }

  // "M/US 6-8" or "M (6-8)" reads as "M · US 6–8" beside the Size label
  function sizeLabel(value) {
    if (!value) return '';
    return value.replace(/\s*\((.+)\)\s*$/, ' · US $1').replace(/\s*\/\s*US\s*/, ' · US ').replace(/-/g, '–');
  }

  VariantForm.prototype.selected = function () {
    return this.fieldsets.map(function (fs) {
      var checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });
  };

  VariantForm.prototype.match = function (sel) {
    if (!this.fieldsets.length) return this.variants[0] || null;
    if (sel.indexOf(null) > -1) return null;
    return this.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  };

  VariantForm.prototype.onChange = function (fs) {
    fs.classList.remove('is-invalid');
    if (this.error) this.error.hidden = true;
    // The new choice was never made in a value picked earlier (this colour has no L, say):
    // clear the other pickers so the shopper chooses from what it does come in.
    var sel = this.selected();
    if (sel.indexOf(null) === -1 && !this.match(sel)) {
      this.fieldsets.forEach(function (other) {
        if (other === fs) return;
        var checked = $('input:checked', other);
        if (checked) checked.checked = false;
      });
    }
    this.update(true);
  };

  VariantForm.prototype.update = function (fromUser) {
    var sel = this.selected();
    var complete = sel.indexOf(null) === -1;
    var v = this.match(sel);
    var root = this.root;
    var self = this;

    // Availability marks. Two different cases, shown differently:
    //  - the combination exists but is out of stock  -> struck through, "sold out"
    //  - the combination was never made (this colour has no L) -> not offered at all.
    //    The first picker (colour) always shows every value; later pickers hide what
    //    doesn't exist for the choices made so far.
    var auto = null;
    this.fieldsets.forEach(function (fs, i) {
      var open = [];
      $$('[data-value]', fs).forEach(function (pill) {
        var value = pill.getAttribute('data-value');
        var combos = self.variants.filter(function (variant) {
          if (variant.options[i] !== value) return false;
          return sel.every(function (s, j) { return j === i || s === null || variant.options[j] === s; });
        });
        var missing = !combos.length;
        var ok = missing
          ? self.variants.some(function (variant) { return variant.available && variant.options[i] === value; })
          : combos.some(function (variant) { return variant.available; });
        var hide = missing && i > 0;
        pill.classList.toggle('is-missing', hide);
        var input = document.getElementById(pill.getAttribute('for'));
        if (input) input.disabled = hide;
        pill.classList.toggle('is-unavailable', !hide && !ok);
        var sr = $('[data-sr-status]', pill);
        if (sr) sr.textContent = !hide && !ok ? ', sold out' : '';
        if (!hide && ok) open.push(input);
      });
      // one value left for this choice and nothing picked yet: pick it for the shopper
      if (i > 0 && sel[i] === null && open.length === 1 && open[0] &&
          $$('[data-value]:not(.is-missing)', fs).length === 1) auto = open[0];
      var chosen = $('[data-option-chosen]', fs);
      if (chosen) chosen.textContent = fs.hasAttribute('data-size-option') ? sizeLabel(sel[i]) : (sel[i] || '');
    });
    if (auto) { auto.checked = true; return this.update(fromUser); }
    var choice = $('[data-sticky-choice]', root);
    if (choice) {
      var picked = sel.filter(Boolean);
      choice.textContent = picked.length ? '· ' + picked.join(' / ') : '';
    }

    if (this.idInput && v) this.idInput.value = v.id;

    // price
    var ref = v || (this.variants.length ? this.variants.filter(function (x) {
      return x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; });
    })[0] : null);
    var priceEl = $('[data-price]', root);
    if (priceEl && ref) {
      var sale = ref.compare_at_price > ref.price;
      priceEl.classList.toggle('vm-price--sale', sale);
      $('[data-price-now]', priceEl).textContent = money(ref.price);
      var was = $('[data-price-was]', priceEl);
      if (was) { was.hidden = !sale; if (sale) $('s', was).textContent = money(ref.compare_at_price); }
      var bnpl = $('[data-bnpl]', root);
      if (bnpl) bnpl.textContent = bnpl.getAttribute('data-bnpl-template').replace('[amount]', money(Math.floor(ref.price / 4)));
      var sticky = $('[data-sticky-price]', root);
      if (sticky) sticky.textContent = money(ref.price);
    }

    // button
    var label = VM.strings.addToBag, disabled = false;
    if (complete && !v) { label = VM.strings.unavailable; disabled = true; }
    else if (v && !v.available) { label = VM.strings.soldOut; disabled = true; }
    if (this.button) { this.button.textContent = label; this.button.disabled = disabled; }
    var stickyBtn = $('[data-sticky-add]', root);
    if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = disabled; }

    // Honest low stock: only from real, tracked inventory (qty is null when untracked)
    var stock = $('[data-stock]', root);
    if (stock) {
      var q = v ? v.qty : null;
      var low = v && v.available && q !== null && q > 0 && q <= 5;
      stock.hidden = !low;
      if (low) stock.textContent = 'Only ' + q + ' left' + ($('[data-size-option]', root) ? ' in this size' : '');
    }
    // Sold out in the chosen size: point to similar pieces instead of a dead end
    var alt = $('[data-soldout-alt]', root);
    if (alt) alt.hidden = !(v && !v.available && document.getElementById('vm-similar'));

    if (this.isPDP) root.dispatchEvent(new CustomEvent('vm:variant', { bubbles: true, detail: { options: sel } }));

    if (fromUser && v) {
      if (this.isPDP) {
        var url = withQuery(window.location.href, { variant: v.id });
        window.history.replaceState({}, '', url);
      }
      if (v.media_id) Gallery.goTo(root, v.media_id);
    }
  };

  VariantForm.prototype.missing = function () {
    var sel = this.selected();
    return this.fieldsets.filter(function (fs, i) { return sel[i] === null; });
  };

  VariantForm.prototype.flagMissing = function () {
    var missing = this.missing();
    if (!missing.length) return false;
    missing.forEach(function (fs) { fs.classList.add('is-invalid'); });
    if (this.error) {
      var names = missing.map(function (fs) { return ($('.vm-option__name', fs) || {}).textContent || 'an option'; });
      this.error.textContent = 'Choose a ' + names.join(' and ').toLowerCase() + '.';
      this.error.hidden = false;
    }
    missing[0].scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
    var first = $('input', missing[0]);
    if (first) first.focus({ preventScroll: true });
    return true;
  };

  VariantForm.prototype.onSubmit = function (e) {
    e.preventDefault();
    if (this.flagMissing()) return;
    var self = this;
    var btn = this.button;
    if (btn) btn.classList.add('is-loading');
    var qty = this.form.querySelector('[name="quantity"]');
    var items = [{ id: parseInt(this.idInput.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 }];
    var sheet = this.root.closest('[data-sheet]');
    if (sheet) closeOverlay(sheet);
    Cart.add(items, btn)
      .then(function () { if (self.error) self.error.hidden = true; })
      .catch(function (err) { if (self.error) { self.error.textContent = err.message; self.error.hidden = false; } })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  };

  function initForms(ctx) {
    $$('[data-variant-form]', ctx).forEach(function (root) { if (!root._vf) new VariantForm(root); });
  }

  /* ---------- 6. Quick add + one-tap add -------------------------------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      var sheet = overlayEl('sheet', 'quick-add');
      var body = $('[data-quick-add-body]', sheet);
      if (!sheet || !body) { window.location.href = qa.getAttribute('data-quick-add'); return; }
      body.innerHTML = '';
      body.classList.add('is-loading');
      openOverlay(sheet, qa);
      fetch(withQuery(qa.getAttribute('data-quick-add'), { section_id: 'quick-add' }))
        .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
        .then(function (html) {
          var content = $('.vm-qa', parseHTML(html));
          if (!content) throw new Error();
          body.appendChild(content);
          body.classList.remove('is-loading');
          initForms(body);
          var first = $('input:not([type="hidden"]), button', body);
          if (first) first.focus({ preventScroll: true });
        })
        .catch(function () { window.location.href = qa.getAttribute('data-quick-add'); });
      return;
    }
    var one = e.target.closest('[data-add-variant]');
    if (one) {
      e.preventDefault();
      Cart.add([{ id: parseInt(one.getAttribute('data-add-variant'), 10), quantity: 1 }], one).catch(function () {});
    }
  });

  /* ---------- 7. PDP ---------------------------------------------------- */
  var Gallery = {
    init: function (root) {
      var track = $('[data-gallery-track]', root);
      var index = $('[data-gallery-index]', root);
      if (!track) return;
      if (index) track.addEventListener('scroll', function () {
        if (isDesktop()) return;
        index.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
      }, { passive: true });
    },
    // Picking a colour brings that colour's image to the front of the gallery.
    goTo: function (root, mediaId) {
      var track = $('[data-gallery-track]', root);
      var media = track && $('[data-media-id="' + mediaId + '"]', track);
      if (!media) return;
      var slide = media.closest('[data-slide]');
      if (slide !== track.firstElementChild) track.insertBefore(slide, track.firstElementChild);
      if (!isDesktop()) {
        track.scrollTo({ left: 0, behavior: 'auto' });
        var index = $('[data-gallery-index]', root);
        if (index) index.textContent = 1;
      }
    }
  };

  // Zoom view: opens scrolled to the image that was tapped.
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom]');
    if (!z) return;
    var drawer = overlayEl('drawer', 'zoom');
    if (!drawer) return;
    openOverlay(drawer, z);
    var item = $('[data-zoom-item="' + z.getAttribute('data-zoom') + '"]', drawer);
    if (item) requestAnimationFrame(function () { item.scrollIntoView({ block: 'start' }); });
  });

  /* ---------- 7b. Complete the look (bundle builder) ------------------- */
  function Bundle(root) {
    var form = $('[data-bundle-form]', root);
    if (!form) return;
    var items = $$('[data-bundle-item]', root).map(function (el) {
      var json = $('[data-bundle-json]', el);
      return {
        el: el,
        toggle: $('[data-bundle-toggle]', el),
        selects: $$('[data-bundle-option]', el),
        priceEl: $('[data-bundle-price]', el),
        variants: json ? JSON.parse(json.textContent) : []
      };
    });
    var totalEl = $('[data-bundle-total]', root);
    var submit = $('[data-bundle-submit]', root);
    var error = $('[data-bundle-error]', root);

    // Inline option pickers: trigger buttons carry the chosen value in data-value
    function val(trig) { return trig.getAttribute('data-value') || null; }
    function panelFor(it, i) { return $('[data-bundle-panel="' + i + '"]', it.el); }
    function setVal(it, i, value) {
      var trig = it.selects[i];
      if (!trig) return;
      trig.setAttribute('data-value', value || '');
      var label = $('[data-bopt-value]', trig);
      if (label) label.textContent = value || 'Choose';
      var panel = panelFor(it, i);
      if (panel) $$('[data-bopt-choice]', panel).forEach(function (c) {
        c.setAttribute('aria-selected', c.getAttribute('data-bopt-choice') === value ? 'true' : 'false');
      });
    }
    function closePanels(except) {
      items.forEach(function (it) {
        it.selects.forEach(function (trig, i) {
          var panel = panelFor(it, i);
          if (!panel || panel === except) return;
          panel.hidden = true;
          trig.setAttribute('aria-expanded', 'false');
        });
      });
    }
    function itemOf(el) { var row = el.closest('[data-bundle-item]'); return items.filter(function (it) { return it.el === row; })[0]; }
    function changed(it) {
      if (it) it.el.classList.remove('is-invalid');
      if (error) error.hidden = true;
      refresh();
    }
    form.addEventListener('click', function (e) {
      var trig = e.target.closest('.vm-bopt__trigger');
      if (trig) {
        e.preventDefault();
        var it = itemOf(trig);
        var panel = it && panelFor(it, parseInt(trig.getAttribute('data-bundle-option'), 10));
        if (!panel) return;
        var open = panel.hidden;
        closePanels(open ? panel : null);
        panel.hidden = !open;
        trig.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var sel = $('[aria-selected="true"]', panel) || $('[data-bopt-choice]', panel); if (sel) sel.focus({ preventScroll: true }); }
        return;
      }
      var choice = e.target.closest('[data-bopt-choice]');
      if (choice) {
        e.preventDefault();
        var it2 = itemOf(choice);
        var pnl = choice.closest('[data-bundle-panel]');
        var i = parseInt(pnl.getAttribute('data-bundle-panel'), 10);
        setVal(it2, i, choice.getAttribute('data-bopt-choice'));
        // this colour was never made in the size picked earlier: ask for the size again
        if (it2.selects.every(function (t) { return val(t); }) && !resolve(it2)) {
          it2.selects.forEach(function (t, j) { if (j !== i) setVal(it2, j, ''); });
        }
        pnl.hidden = true;
        it2.selects[i].setAttribute('aria-expanded', 'false');
        it2.selects[i].focus({ preventScroll: true });
        changed(it2);
      }
    });
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var pnl = e.target.closest('[data-bundle-panel]');
      if (!pnl || pnl.hidden) return;
      e.stopPropagation();
      var it = itemOf(pnl);
      var i = parseInt(pnl.getAttribute('data-bundle-panel'), 10);
      pnl.hidden = true;
      it.selects[i].setAttribute('aria-expanded', 'false');
      it.selects[i].focus();
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closePanels(null); });

    function resolve(it) {
      if (!it.selects.length) return it.variants[0] || null;
      var sel = it.selects.map(val);
      if (sel.indexOf(null) > -1) return null;
      return it.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
    }
    function priceOf(it) {
      var v = resolve(it);
      if (v) return v.price;
      var sel = it.selects.map(val);
      var m = it.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); })[0];
      return m ? m.price : (it.variants[0] ? it.variants[0].price : 0);
    }
    function refresh() {
      var total = 0, count = 0;
      items.forEach(function (it) {
        var p = priceOf(it);
        if (it.priceEl) it.priceEl.textContent = money(p);
        // mark sold-out combinations in each picker
        it.selects.forEach(function (s, i) {
          var panel = panelFor(it, i);
          if (!panel) return;
          $$('[data-bopt-choice]', panel).forEach(function (o) {
            var value = o.getAttribute('data-bopt-choice');
            var combos = it.variants.filter(function (v) {
              if (v.options[i] !== value) return false;
              return it.selects.every(function (other, j) { return j === i || !val(other) || v.options[j] === val(other); });
            });
            // never made in this combination: don't offer it (it isn't "sold out")
            var missing = !combos.length;
            var ok = missing
              ? it.variants.some(function (v) { return v.available && v.options[i] === value; })
              : combos.some(function (v) { return v.available; });
            o.classList.toggle('is-missing', missing && i > 0);
            o.classList.toggle('is-unavailable', !(missing && i > 0) && !ok);
          });
        });
        it.el.classList.toggle('is-off', !it.toggle.checked);
        if (it.toggle.checked) { total += p; count++; }
      });
      // Volume tier for the pieces ticked plus what's already in the bag
      var tier = Savings.tierFor(count + (VM.cartCount || 0));
      var wasEl = $('[data-bundle-was]', root);
      var saveEl = $('[data-bundle-saving]', root);
      if (tier && count > 0) {
        if (wasEl) { wasEl.textContent = money(total); wasEl.hidden = false; }
        if (totalEl) totalEl.textContent = money(Math.round(total * (100 - tier.pct) / 100));
        if (saveEl) { saveEl.innerHTML = '<strong>' + tier.pct + '% off</strong> your order, applied automatically at checkout'; saveEl.hidden = false; }
      } else {
        if (wasEl) wasEl.hidden = true;
        if (totalEl) totalEl.textContent = money(total);
        if (saveEl) saveEl.hidden = true;
      }
      if (submit) {
        submit.disabled = count === 0;
        submit.textContent = count > 1 ? 'Add ' + count + ' pieces to bag' : (count === 1 ? 'Add to bag' : 'Choose a piece');
      }
    }
    document.addEventListener('vm:cart', function () { refresh(); });
    form.addEventListener('change', function (e) { changed(itemOf(e.target)); });
    // "This piece" follows the main buy box
    document.addEventListener('vm:variant', function (e) {
      var cur = items.filter(function (it) { return it.el.hasAttribute('data-bundle-current'); })[0];
      if (!cur) return;
      (e.detail.options || []).forEach(function (val, i) {
        if (cur.selects[i] && val !== null) setVal(cur, i, val);
      });
      refresh();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var chosen = items.filter(function (it) { return it.toggle.checked; });
      var missing = chosen.filter(function (it) { var v = resolve(it); return !v || !v.available; });
      if (missing.length) {
        missing.forEach(function (it) { it.el.classList.add('is-invalid'); });
        if (error) {
          error.textContent = missing.some(function (it) { return !resolve(it); })
            ? 'Choose a size for each ticked piece.'
            : 'One of those sizes is sold out. Pick another or untick it.';
          error.hidden = false;
        }
        var first = missing[0].selects.filter(function (t) { return !val(t); })[0] || missing[0].selects[0];
        if (first) first.focus();
        return;
      }
      submit.classList.add('is-loading');
      Cart.add(chosen.map(function (it) { return { id: resolve(it).id, quantity: 1 }; }), submit)
        .catch(function () {})
        .finally(function () { submit.classList.remove('is-loading'); });
    });
    refresh();
  }

  function lazyVideos() {
    var vids = $$('video[data-lazy-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !reducedMotion) { v.play().catch(function () {}); }
        else if (!en.isIntersecting) { v.pause(); }
      });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  }

  function stickyATC() {
    var root = $('[data-pdp]');
    if (!root) return;
    var bar = $('[data-sticky-atc]', root);
    var main = $('[data-main-atc]', root);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = $('[data-sticky-add]', bar);
      if (btn) btn.tabIndex = show ? 0 : -1;
    }).observe(main);
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sticky-add]')) return;
      var vf = root._vf;
      if (!vf) return;
      if (vf.flagMissing()) return;
      vf.form.requestSubmit ? vf.form.requestSubmit() : vf.form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  function styledWith() {
    $$('[data-complementary-url]').forEach(function (box) {
      fetch(box.getAttribute('data-complementary-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var items = $$('.vm-styled__item', parseHTML(html));
          if (!items.length) return;
          var list = $('[data-styled-list]', box);
          items.forEach(function (it) { list.appendChild(it); });
          box.hidden = false;
        })
        .catch(function () {});
    });
  }

  // "You may also like": the page ships a fallback row; swap in Shopify's personalised
  // recommendations only when the endpoint actually returns some.
  function recommendations() {
    $$('[data-recommendations]').forEach(function (sec) {
      var load = function () {
        fetch(sec.getAttribute('data-url'))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var live = html && $('[data-recs-live]', parseHTML(html));
            if (live) { sec.innerHTML = live.outerHTML; railArrows(); }
          })
          .catch(function () {});
      };
      if (!('IntersectionObserver' in window)) return load();
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(sec);
    });
  }

  // Recently viewed: handles live in this browser only.
  function recentlyViewed() {
    var sec = $('[data-recently-viewed]');
    var KEY = 'vm_recent';
    var list = [];
    try { list = JSON.parse((local && local.getItem(KEY)) || '[]'); } catch (e) { list = []; }
    var pdp = $('[data-pdp]');
    var current = sec ? sec.getAttribute('data-current') : null;
    if (pdp && current) {
      var next = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 12);
      if (local) try { local.setItem(KEY, JSON.stringify(next)); } catch (e) {}
    }
    if (!sec) return;
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 6;
    var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;
    var ul = $('[data-recent-list]', sec);
    Promise.all(handles.map(function (h) {
      return fetch((VM.routes.root || '/') + 'products/' + encodeURIComponent(h) + '?section_id=product-card-render')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return html ? $('.vm-card', parseHTML(html)) : null; })
        .catch(function () { return null; });
    })).then(function (cards) {
      cards.filter(Boolean).forEach(function (card) {
        var li = document.createElement('li');
        li.appendChild(card);
        ul.appendChild(li);
      });
      if (ul.children.length) { sec.hidden = false; railArrows(); }
    });
  }

  /* ---------- 8. Hero video: poster first, video after load ------------- */
  function heroVideo() {
    var v = $('[data-hero-video]');
    if (!v || reducedMotion) return;
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    var start = function () {
      $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
      v.load();
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      v.play().catch(function () {});
    };
    if (document.readyState === 'complete') setTimeout(start, 300);
    else window.addEventListener('load', function () { setTimeout(start, 300); });
  }

  /* ---------- 9. Predictive search -------------------------------------- */
  function search() {
    var input = $('[data-predictive-input]');
    var out = $('[data-predictive-results]');
    if (!input || !out || !VM.routes.predictive) return;
    var timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        var url = VM.routes.predictive + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=4&resources[options][prefix]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var doc = parseHTML(html);
            var sec = $('.shopify-section', doc) || doc.body;
            out.innerHTML = sec.innerHTML;
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- 10. Collection tools -------------------------------------- */
  function collectionTools() {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var to = withQuery(window.location.href, { sort_by: sort.value, page: 1 });
      if (collectionLoad) collectionLoad(to, true, false); else window.location.href = to;
    });

    var grid = $('[data-product-grid]');
    var toggles = $$('[data-grid-cols]');
    if (!grid || !toggles.length) return;
    var apply = function (cols) {
      grid.classList.toggle('is-1col', cols === '1');
      toggles.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-grid-cols') === cols ? 'true' : 'false'); });
    };
    var saved = local ? local.getItem('vm_grid_cols') : null;
    if (saved) apply(saved);
    toggles.forEach(function (b) {
      b.addEventListener('click', function () {
        var cols = b.getAttribute('data-grid-cols');
        apply(cols);
        if (local) try { local.setItem('vm_grid_cols', cols); } catch (e) {}
      });
    });
  }

  /* ---------- 12. Email popup ------------------------------------------- */
  function emailPopup() {
    var el = $('[data-email-popup]');
    var hash = window.location.hash;

    // after a signup posts, Shopify reloads with #<form id>
    if (/^#EmailSignup-/.test(hash)) {
      var sms = $('[data-sms-step]');
      if (sms && $('[data-email-success]', document)) sms.hidden = false;
    }
    // A successful signup (any form) reveals the welcome code in its own sheet
    var justSignedUp = /customer_posted=true/.test(window.location.search) && $('[data-email-success]');
    if (justSignedUp) {
      if (local) try { local.setItem('vm_subscribed', '1'); } catch (e) {}
      var welcome = overlayEl('sheet', 'welcome-code');
      if (welcome) setTimeout(function () { openOverlay(welcome); }, 300);
      return;
    }
    if (!el) return;
    if ($('[data-email-success]')) { if (local) try { local.setItem('vm_subscribed', '1'); } catch (e) {} }
    if (local && local.getItem('vm_subscribed')) return;
    var dismissed = local ? parseInt(local.getItem('vm_popup_dismissed') || '0', 10) : 0;
    if (dismissed && Date.now() - dismissed < 14 * 864e5) return;

    // never on a first product-page view from paid traffic
    var params = new URLSearchParams(window.location.search);
    var medium = (params.get('utm_medium') || '').toLowerCase();
    var paid = /^(cpc|ppc|paid|paidsocial|paid_social|paid-social|display)$/.test(medium) ||
      ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'].some(function (k) { return params.has(k); });
    var isPDP = document.body.classList.contains('template-product');
    if (paid && isPDP && session && !session.getItem('vm_pdp_seen')) {
      try { session.setItem('vm_pdp_seen', '1'); } catch (e) {}
      return;
    }
    if (isPDP && session) try { session.setItem('vm_pdp_seen', '1'); } catch (e) {}

    var shown = false;
    var show = function () {
      if (shown) return;
      if (openStack.length) { setTimeout(show, 5000); return; }
      shown = true;
      openOverlay(el);
    };
    var delay = (parseInt(el.getAttribute('data-delay'), 10) || 15) * 1000;
    setTimeout(show, delay);
    if (window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); show(); }
      });
    }
    el.addEventListener('vm:closed', function () {
      if (local) try { local.setItem('vm_popup_dismissed', String(Date.now())); } catch (e) {}
    });
  }

  /* ---------- 13. FAQ page: live search + topic highlighting ----------- */
  function faqPage() {
    var root = $('[data-faq]');
    if (!root) return;
    var input = $('[data-faq-search]', root);
    var empty = $('[data-faq-empty]', root);
    var groups = $$('[data-faq-group]', root);
    var items = $$('[data-faq-item]', root);
    var norm = function (t) { return (t || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
    items.forEach(function (it) { it._text = norm(it.textContent); });

    if (input) input.addEventListener('input', function () {
      var q = norm(input.value);
      var words = q ? q.split(' ') : [];
      var shown = 0;
      items.forEach(function (it) {
        var hit = words.every(function (w) { return it._text.indexOf(w) > -1; });
        it.hidden = !hit;
        if (q) it.open = hit; else it.open = false;
        if (hit) shown++;
      });
      groups.forEach(function (g) {
        g.hidden = !$$('[data-faq-item]', g).some(function (it) { return !it.hidden; });
      });
      if (empty) empty.hidden = shown > 0;
    });

    // Highlight the topic currently in view in the chip / side menu
    var chips = $$('[data-faq-chip]', root);
    if (!chips.length || !('IntersectionObserver' in window)) return;
    var byId = {};
    chips.forEach(function (c) { byId[c.getAttribute('data-faq-chip')] = c; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id.replace('faq-', '');
        chips.forEach(function (c) { c.classList.toggle('is-active', c === byId[id]); c.removeAttribute('aria-current'); });
        if (byId[id]) byId[id].setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---------- 14. Size chart units (in / cm) --------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-unit-toggle]');
    if (!btn) return;
    var unit = btn.getAttribute('data-unit-toggle');
    $$('[data-unit-root]').forEach(function (root) {
      root.classList.toggle('is-cm', unit === 'cm');
      $$('[data-unit-toggle]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unit-toggle') === unit ? 'true' : 'false'); });
    });
    if (local) try { local.setItem('vm_unit', unit); } catch (err) {}
  });
  (function restoreUnit() {
    var unit = local ? local.getItem('vm_unit') : null;
    if (unit !== 'cm') return;
    $$('[data-unit-root]').forEach(function (root) {
      root.classList.add('is-cm');
      $$('[data-unit-toggle]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unit-toggle') === 'cm' ? 'true' : 'false'); });
    });
  })();

  /* ---------- 15. Policy pages: "On this page" list -------------------- */
  (function policyToc() {
    var body = $('[data-policy-body]');
    var toc = $('[data-policy-toc]');
    if (!body || !toc) return;
    var list = $('[data-policy-toc-list]', toc);
    var heads = $$('h2', body);
    if (heads.length < 3) return;
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'policy-' + (h.textContent || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'policy-' + i;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  })();

  /* ---------- 16. Copy-to-clipboard (welcome code) ---------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn) return;
    var text = btn.getAttribute('data-copy');
    var done = function () {
      var label = btn.textContent;
      btn.textContent = 'Copied';
      btn.classList.add('is-copied');
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-copied'); }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { selectCode(btn); });
    } else {
      selectCode(btn);
    }
  });
  function selectCode(btn) {
    var code = btn.parentElement && $('[data-wcode]', btn.parentElement);
    if (!code) return;
    var range = document.createRange();
    range.selectNodeContents(code);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  /* ---------- Desktop: carousel arrows, hover quick add, no-reload shop page ---------- */
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CHEVRON = { prev: 'm14.5 6.5-5.5 5.5 5.5 5.5', next: 'm9.5 6.5 5.5 5.5-5.5 5.5' };
  function svgIcon(d) {
    return '<svg class="vm-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  }

  // Product rails: previous / next arrows for mouse users (touch keeps the swipe)
  function railArrows() {
    if (!finePointer.matches) return;
    $$('.vm-rail').forEach(function (rail) {
      if (rail._arrows || rail.scrollWidth <= rail.clientWidth + 4) return;
      rail._arrows = true;
      var wrap = document.createElement('div');
      wrap.className = 'vm-rail-wrap';
      rail.parentNode.insertBefore(wrap, rail);
      wrap.appendChild(rail);
      var btns = ['prev', 'next'].map(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vm-rail__arrow vm-rail__arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous products' : 'More products');
        b.innerHTML = svgIcon(CHEVRON[dir]);
        b.addEventListener('click', function () {
          rail.scrollBy({ left: (dir === 'prev' ? -1 : 1) * rail.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
        wrap.appendChild(b);
        return b;
      });
      var sync = function () {
        btns[0].disabled = rail.scrollLeft < 8;
        btns[1].disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      };
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  // Sizes in natural order (same ranking as snippets/size-order.liquid)
  var SIZE_RANK = ['XXS', '2XS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL'];
  function sizeKey(value) { return String(value).split(/[\s\/(]/)[0].toUpperCase(); }
  function bySize(a, b) {
    var x = SIZE_RANK.indexOf(sizeKey(a)), y = SIZE_RANK.indexOf(sizeKey(b));
    return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
  }

  // Product cards on desktop: hover shows the sizes of the colour pictured; one click adds it.
  // Product data loads on first hover, so cards stay light. Touch keeps the "+" size sheet.
  function hoverQuickAdd() {
    if (!finePointer.matches) return;
    var build = function (card) {
      if (card._sizes) return;
      var quick = $('[data-quick-add]', card);
      var media = $('.vm-card__media', card);
      if (!quick || !media) return;
      card._sizes = true;
      var url = quick.getAttribute('data-quick-add');
      fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (p) {
          var names = p.options.map(function (o) { return String(o.name || o).toLowerCase(); });
          var si = -1, ci = -1;
          names.forEach(function (n, i) { if (n.indexOf('size') > -1) si = i; else if (n === 'color' || n === 'colour') ci = i; });
          // the colour to add is the one in the card's photo (the product's first image),
          // not simply the first variant
          var cover = p.media && p.media[0] ? p.media[0].id : null;
          var pictured = p.variants.filter(function (v) { return cover && v.featured_media && v.featured_media.id === cover; });
          var shown = pictured.filter(function (v) { return v.available; })[0] || pictured[0] ||
            p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
          if (!shown) return;
          var colour = ci > -1 ? shown.options[ci] : null;
          var pool = p.variants.filter(function (v) { return ci < 0 || v.options[ci] === colour; });
          var html = '';
          if (si > -1 && p.options.length <= 2) {
            pool.slice().sort(function (a, b) { return bySize(a.options[si], b.options[si]); }).forEach(function (v) {
              var full = v.options[si];
              html += '<button type="button" class="vm-card__size' + (v.available ? '' : ' is-unavailable') + '"' +
                (v.available ? ' data-add-variant="' + v.id + '"' : ' disabled') +
                ' title="' + full.replace(/"/g, '&quot;') + '" aria-label="Add size ' + full.replace(/"/g, '&quot;') + ' to bag">' + sizeKey(full) + '</button>';
            });
          } else if (p.variants.length === 1 && shown.available) {
            html = '<button type="button" class="vm-card__size vm-card__size--wide" data-add-variant="' + shown.id + '">' + VM.strings.addToBag + '</button>';
          }
          if (!html) { card._sizes = false; return; }
          var panel = document.createElement('div');
          panel.className = 'vm-card__sizes';
          var colours = ci > -1 ? (p.options[ci].values || []).length : 0;
          panel.innerHTML = '<p class="vm-card__sizes-label"><span>Quick add' + (colour ? ' · ' + colour : '') + '</span>' +
            (colours > 1 ? '<button type="button" class="vm-card__sizes-more" data-quick-add="' + url + '">' + colours + ' colors</button>' : '') + '</p>' +
            '<div class="vm-card__sizes-row">' + html + '</div>';
          media.appendChild(panel);
          card.classList.add('has-sizes');
        })
        .catch(function () { card._sizes = false; });
    };
    var onEnter = function (e) {
      var card = e.target.closest && e.target.closest('[data-product-card]');
      if (!card) return;
      // second photo: fetched on first hover only
      var hov = $('.vm-card__img--hover[data-srcset], .vm-card__img--hover[data-src]', card);
      if (hov) {
        if (hov.getAttribute('data-srcset')) hov.srcset = hov.getAttribute('data-srcset');
        if (hov.getAttribute('data-src')) hov.src = hov.getAttribute('data-src');
        hov.removeAttribute('data-srcset'); hov.removeAttribute('data-src');
      }
      build(card);
    };
    document.addEventListener('mouseover', onEnter, { passive: true });
    document.addEventListener('focusin', onEnter);
  }

  // Shop page: filters, sort and pages refresh in place (no full reload); the URL stays shareable
  // and Back works. Falls back to normal navigation if anything goes wrong.
  var collectionLoad = null;
  function collectionAjax() {
    var root = $('.vm-collection');
    var wrap = root && root.closest('.shopify-section');
    if (!root || !wrap || !window.history || !history.pushState) return;
    var sid = wrap.id.replace('shopify-section-', '');
    var busy = false;
    collectionLoad = function (url, push, toTop) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');
      fetch(withQuery(url, { section_id: sid }))
        .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
        .then(function (html) {
          var fresh = $('.vm-collection', parseHTML(html));
          if (!fresh) throw new Error();
          var open = $('[data-drawer="filters"]:not([hidden])', root);
          if (open) closeOverlay(open);
          root.innerHTML = fresh.innerHTML;
          if (push) history.pushState({ vmCollection: true }, '', url);
          collectionTools();
          if (toTop) {
            var top = root.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--vm-sticky-top'), 10) || 0) - 16;
            window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
          }
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { busy = false; root.classList.remove('is-loading'); });
    };
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      var a = e.target.closest('.vm-collection .vm-facets a, .vm-collection [data-drawer="filters"] a, .vm-collection .vm-pagination a');
      if (!a || a.origin !== window.location.origin) return;
      e.preventDefault();
      collectionLoad(a.href, true, !!a.closest('.vm-pagination'));
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.vm-collection [data-filter-form]');
      if (!form) return;
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      var qs = params.toString();
      collectionLoad(window.location.pathname + (qs ? '?' + qs : ''), true, false);
    });
    window.addEventListener('popstate', function () { if (collectionLoad) collectionLoad(window.location.href, false, false); });
  }

  /* ---------- Announcement bar: one message at a time on phones --------- */
  function announce() {
    var bar = $('[data-announce-rotate]');
    if (!bar) return;
    var items = $$('[data-announce-item]', bar);
    var phone = window.matchMedia('(max-width: 749px)');
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (items.length < 2 || calm.matches) return;
    var every = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--vm-announce-every'), 10) || 5000;
    var i = 0, paused = false;
    bar.addEventListener('pointerenter', function () { paused = true; });
    bar.addEventListener('pointerleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || !phone.matches || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, every);
  }

  /* ---------- Boot ------------------------------------------------------ */
  function boot() {
    announce();
    railArrows();
    hoverQuickAdd();
    collectionAjax();
    initForms(document);
    $$('[data-gallery]').forEach(function (g) { Gallery.init(g.closest('[data-pdp]') || g); });
    lazyVideos();
    stickyATC();
    $$('[data-bundle]').forEach(Bundle);
    styledWith();
    recommendations();
    recentlyViewed();
    heroVideo();
    search();
    collectionTools();
    emailPopup();
    faqPage();
    Savings.card();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.VMCart = Cart;
})();
